export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrow-left-7e70aa4d6f4fdd920c431641321e979b.svg";